/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateEstimateRequest,
  CreateLineItemRequest,
  CreateRoomRequest,
  EstimateDetailed,
  EstimateLineItem,
  EstimateListResponse,
  EstimateResponse,
  EstimateStats,
  GetEstimateWorkflowsByClaimId200Response,
  Problem,
  RoomDetail,
  UpdateEstimateRequest,
  UpdateLineItemRequest,
} from '../models/index';
import {
    CreateEstimateRequestFromJSON,
    CreateEstimateRequestToJSON,
    CreateLineItemRequestFromJSON,
    CreateLineItemRequestToJSON,
    CreateRoomRequestFromJSON,
    CreateRoomRequestToJSON,
    EstimateDetailedFromJSON,
    EstimateDetailedToJSON,
    EstimateLineItemFromJSON,
    EstimateLineItemToJSON,
    EstimateListResponseFromJSON,
    EstimateListResponseToJSON,
    EstimateResponseFromJSON,
    EstimateResponseToJSON,
    EstimateStatsFromJSON,
    EstimateStatsToJSON,
    GetEstimateWorkflowsByClaimId200ResponseFromJSON,
    GetEstimateWorkflowsByClaimId200ResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    RoomDetailFromJSON,
    RoomDetailToJSON,
    UpdateEstimateRequestFromJSON,
    UpdateEstimateRequestToJSON,
    UpdateLineItemRequestFromJSON,
    UpdateLineItemRequestToJSON,
} from '../models/index';

export interface CancelEstimateWorkflowRequest {
    workflowId: string;
}

export interface CreateEstimateOperationRequest {
    createEstimateRequest: CreateEstimateRequest;
}

export interface CreateLineItemOperationRequest {
    id: number;
    createLineItemRequest: CreateLineItemRequest;
}

export interface CreateRoomOperationRequest {
    estimateId: number;
    createRoomRequest: CreateRoomRequest;
}

export interface DeleteEstimateRequest {
    estimateId: number;
}

export interface DeleteLineItemRequest {
    id: number;
}

export interface DeleteRoomRequest {
    id: number;
}

export interface GetEstimateRequest {
    estimateId: number;
}

export interface GetEstimateDetailedRequest {
    estimateId: number;
}

export interface GetEstimateWorkflowsByClaimIdRequest {
    claimId: number;
}

export interface ListEstimatesRequest {
    page?: number;
    limit?: number;
    claimId?: number;
    kind?: ListEstimatesKindEnum;
}

export interface UpdateEstimateOperationRequest {
    estimateId: number;
    updateEstimateRequest: UpdateEstimateRequest;
}

export interface UpdateLineItemOperationRequest {
    id: number;
    updateLineItemRequest: UpdateLineItemRequest;
}

/**
 * EstimatesApi - interface
 * 
 * @export
 * @interface EstimatesApiInterface
 */
export interface EstimatesApiInterface {
    /**
     * Cancels an in-progress estimate extraction workflow
     * @summary Cancel an estimate workflow
     * @param {string} workflowId ID of the workflow to cancel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    cancelEstimateWorkflowRaw(requestParameters: CancelEstimateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Cancels an in-progress estimate extraction workflow
     * Cancel an estimate workflow
     */
    cancelEstimateWorkflow(requestParameters: CancelEstimateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * 
     * @summary Create an estimate
     * @param {CreateEstimateRequest} createEstimateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    createEstimateRaw(requestParameters: CreateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateResponse>>;

    /**
     * Create an estimate
     */
    createEstimate(requestParameters: CreateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateResponse>;

    /**
     * 
     * @summary Create a new line item in a room
     * @param {number} id 
     * @param {CreateLineItemRequest} createLineItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    createLineItemRaw(requestParameters: CreateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateLineItem>>;

    /**
     * Create a new line item in a room
     */
    createLineItem(requestParameters: CreateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateLineItem>;

    /**
     * 
     * @summary Create a new room in an estimate
     * @param {number} estimateId 
     * @param {CreateRoomRequest} createRoomRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    createRoomRaw(requestParameters: CreateRoomOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomDetail>>;

    /**
     * Create a new room in an estimate
     */
    createRoom(requestParameters: CreateRoomOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomDetail>;

    /**
     * 
     * @summary Delete an estimate by id
     * @param {number} estimateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    deleteEstimateRaw(requestParameters: DeleteEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete an estimate by id
     */
    deleteEstimate(requestParameters: DeleteEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete a line item
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    deleteLineItemRaw(requestParameters: DeleteLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a line item
     */
    deleteLineItem(requestParameters: DeleteLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Delete an empty room
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    deleteRoomRaw(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete an empty room
     */
    deleteRoom(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * 
     * @summary Get an estimate by id (detailed)
     * @param {number} estimateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    getEstimateRaw(requestParameters: GetEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateResponse>>;

    /**
     * Get an estimate by id (detailed)
     */
    getEstimate(requestParameters: GetEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateResponse>;

    /**
     * 
     * @summary Get the fully detailed estimate payload
     * @param {number} estimateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    getEstimateDetailedRaw(requestParameters: GetEstimateDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateDetailed>>;

    /**
     * Get the fully detailed estimate payload
     */
    getEstimateDetailed(requestParameters: GetEstimateDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateDetailed>;

    /**
     * 
     * @summary Aggregate estimate stats for dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    getEstimateStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateStats>>;

    /**
     * Aggregate estimate stats for dashboards
     */
    getEstimateStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateStats>;

    /**
     * Returns all estimate workflows associated with a specific claim
     * @summary Get estimate workflows by claim ID
     * @param {number} claimId ID of the claim to retrieve workflows for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    getEstimateWorkflowsByClaimIdRaw(requestParameters: GetEstimateWorkflowsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEstimateWorkflowsByClaimId200Response>>;

    /**
     * Returns all estimate workflows associated with a specific claim
     * Get estimate workflows by claim ID
     */
    getEstimateWorkflowsByClaimId(requestParameters: GetEstimateWorkflowsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEstimateWorkflowsByClaimId200Response>;

    /**
     * 
     * @summary List estimates
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {number} [claimId] Filter by claim ID
     * @param {'insurer' | 'contractor'} [kind] Filter by estimate kind
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    listEstimatesRaw(requestParameters: ListEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateListResponse>>;

    /**
     * List estimates
     */
    listEstimates(requestParameters: ListEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateListResponse>;

    /**
     * 
     * @summary Update an estimate by id
     * @param {number} estimateId 
     * @param {UpdateEstimateRequest} updateEstimateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    updateEstimateRaw(requestParameters: UpdateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateResponse>>;

    /**
     * Update an estimate by id
     */
    updateEstimate(requestParameters: UpdateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateResponse>;

    /**
     * 
     * @summary Update a line item
     * @param {number} id 
     * @param {UpdateLineItemRequest} updateLineItemRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EstimatesApiInterface
     */
    updateLineItemRaw(requestParameters: UpdateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateLineItem>>;

    /**
     * Update a line item
     */
    updateLineItem(requestParameters: UpdateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateLineItem>;

}

/**
 * 
 */
export class EstimatesApi extends runtime.BaseAPI implements EstimatesApiInterface {

    /**
     * Cancels an in-progress estimate extraction workflow
     * Cancel an estimate workflow
     */
    async cancelEstimateWorkflowRaw(requestParameters: CancelEstimateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['workflowId'] == null) {
            throw new runtime.RequiredError(
                'workflowId',
                'Required parameter "workflowId" was null or undefined when calling cancelEstimateWorkflow().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimate-workflows/{workflowId}/cancel`.replace(`{${"workflowId"}}`, encodeURIComponent(String(requestParameters['workflowId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Cancels an in-progress estimate extraction workflow
     * Cancel an estimate workflow
     */
    async cancelEstimateWorkflow(requestParameters: CancelEstimateWorkflowRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.cancelEstimateWorkflowRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an estimate
     */
    async createEstimateRaw(requestParameters: CreateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateResponse>> {
        if (requestParameters['createEstimateRequest'] == null) {
            throw new runtime.RequiredError(
                'createEstimateRequest',
                'Required parameter "createEstimateRequest" was null or undefined when calling createEstimate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEstimateRequestToJSON(requestParameters['createEstimateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateResponseFromJSON(jsonValue));
    }

    /**
     * Create an estimate
     */
    async createEstimate(requestParameters: CreateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateResponse> {
        const response = await this.createEstimateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new line item in a room
     */
    async createLineItemRaw(requestParameters: CreateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateLineItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLineItem().'
            );
        }

        if (requestParameters['createLineItemRequest'] == null) {
            throw new runtime.RequiredError(
                'createLineItemRequest',
                'Required parameter "createLineItemRequest" was null or undefined when calling createLineItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/rooms/{id}/line-items`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLineItemRequestToJSON(requestParameters['createLineItemRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateLineItemFromJSON(jsonValue));
    }

    /**
     * Create a new line item in a room
     */
    async createLineItem(requestParameters: CreateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateLineItem> {
        const response = await this.createLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new room in an estimate
     */
    async createRoomRaw(requestParameters: CreateRoomOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoomDetail>> {
        if (requestParameters['estimateId'] == null) {
            throw new runtime.RequiredError(
                'estimateId',
                'Required parameter "estimateId" was null or undefined when calling createRoom().'
            );
        }

        if (requestParameters['createRoomRequest'] == null) {
            throw new runtime.RequiredError(
                'createRoomRequest',
                'Required parameter "createRoomRequest" was null or undefined when calling createRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/{estimateId}/rooms`.replace(`{${"estimateId"}}`, encodeURIComponent(String(requestParameters['estimateId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRoomRequestToJSON(requestParameters['createRoomRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoomDetailFromJSON(jsonValue));
    }

    /**
     * Create a new room in an estimate
     */
    async createRoom(requestParameters: CreateRoomOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoomDetail> {
        const response = await this.createRoomRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an estimate by id
     */
    async deleteEstimateRaw(requestParameters: DeleteEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['estimateId'] == null) {
            throw new runtime.RequiredError(
                'estimateId',
                'Required parameter "estimateId" was null or undefined when calling deleteEstimate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/{estimateId}`.replace(`{${"estimateId"}}`, encodeURIComponent(String(requestParameters['estimateId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an estimate by id
     */
    async deleteEstimate(requestParameters: DeleteEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteEstimateRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a line item
     */
    async deleteLineItemRaw(requestParameters: DeleteLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteLineItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/line-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a line item
     */
    async deleteLineItem(requestParameters: DeleteLineItemRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteLineItemRaw(requestParameters, initOverrides);
    }

    /**
     * Delete an empty room
     */
    async deleteRoomRaw(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteRoom().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/rooms/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete an empty room
     */
    async deleteRoom(requestParameters: DeleteRoomRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteRoomRaw(requestParameters, initOverrides);
    }

    /**
     * Get an estimate by id (detailed)
     */
    async getEstimateRaw(requestParameters: GetEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateResponse>> {
        if (requestParameters['estimateId'] == null) {
            throw new runtime.RequiredError(
                'estimateId',
                'Required parameter "estimateId" was null or undefined when calling getEstimate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/{estimateId}`.replace(`{${"estimateId"}}`, encodeURIComponent(String(requestParameters['estimateId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateResponseFromJSON(jsonValue));
    }

    /**
     * Get an estimate by id (detailed)
     */
    async getEstimate(requestParameters: GetEstimateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateResponse> {
        const response = await this.getEstimateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the fully detailed estimate payload
     */
    async getEstimateDetailedRaw(requestParameters: GetEstimateDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateDetailed>> {
        if (requestParameters['estimateId'] == null) {
            throw new runtime.RequiredError(
                'estimateId',
                'Required parameter "estimateId" was null or undefined when calling getEstimateDetailed().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/{estimateId}/detailed`.replace(`{${"estimateId"}}`, encodeURIComponent(String(requestParameters['estimateId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateDetailedFromJSON(jsonValue));
    }

    /**
     * Get the fully detailed estimate payload
     */
    async getEstimateDetailed(requestParameters: GetEstimateDetailedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateDetailed> {
        const response = await this.getEstimateDetailedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Aggregate estimate stats for dashboards
     */
    async getEstimateStatsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateStats>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateStatsFromJSON(jsonValue));
    }

    /**
     * Aggregate estimate stats for dashboards
     */
    async getEstimateStats(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateStats> {
        const response = await this.getEstimateStatsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns all estimate workflows associated with a specific claim
     * Get estimate workflows by claim ID
     */
    async getEstimateWorkflowsByClaimIdRaw(requestParameters: GetEstimateWorkflowsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetEstimateWorkflowsByClaimId200Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getEstimateWorkflowsByClaimId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimate-workflows/claim/{claimId}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetEstimateWorkflowsByClaimId200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns all estimate workflows associated with a specific claim
     * Get estimate workflows by claim ID
     */
    async getEstimateWorkflowsByClaimId(requestParameters: GetEstimateWorkflowsByClaimIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetEstimateWorkflowsByClaimId200Response> {
        const response = await this.getEstimateWorkflowsByClaimIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List estimates
     */
    async listEstimatesRaw(requestParameters: ListEstimatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['kind'] != null) {
            queryParameters['kind'] = requestParameters['kind'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateListResponseFromJSON(jsonValue));
    }

    /**
     * List estimates
     */
    async listEstimates(requestParameters: ListEstimatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateListResponse> {
        const response = await this.listEstimatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an estimate by id
     */
    async updateEstimateRaw(requestParameters: UpdateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateResponse>> {
        if (requestParameters['estimateId'] == null) {
            throw new runtime.RequiredError(
                'estimateId',
                'Required parameter "estimateId" was null or undefined when calling updateEstimate().'
            );
        }

        if (requestParameters['updateEstimateRequest'] == null) {
            throw new runtime.RequiredError(
                'updateEstimateRequest',
                'Required parameter "updateEstimateRequest" was null or undefined when calling updateEstimate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/{estimateId}`.replace(`{${"estimateId"}}`, encodeURIComponent(String(requestParameters['estimateId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateEstimateRequestToJSON(requestParameters['updateEstimateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateResponseFromJSON(jsonValue));
    }

    /**
     * Update an estimate by id
     */
    async updateEstimate(requestParameters: UpdateEstimateOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateResponse> {
        const response = await this.updateEstimateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a line item
     */
    async updateLineItemRaw(requestParameters: UpdateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EstimateLineItem>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLineItem().'
            );
        }

        if (requestParameters['updateLineItemRequest'] == null) {
            throw new runtime.RequiredError(
                'updateLineItemRequest',
                'Required parameter "updateLineItemRequest" was null or undefined when calling updateLineItem().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/estimates/line-items/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateLineItemRequestToJSON(requestParameters['updateLineItemRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EstimateLineItemFromJSON(jsonValue));
    }

    /**
     * Update a line item
     */
    async updateLineItem(requestParameters: UpdateLineItemOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EstimateLineItem> {
        const response = await this.updateLineItemRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListEstimatesKindEnum = {
    Insurer: 'insurer',
    Contractor: 'contractor'
} as const;
export type ListEstimatesKindEnum = typeof ListEstimatesKindEnum[keyof typeof ListEstimatesKindEnum];
